var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('el-container',[_c('el-main',[_c('Main',{class:{'isIos-main':_vm.platform == 'ios','isAndroid-main': _vm.platform == 'android'}})],1),_c('el-footer',[_c('tabbar')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }